import React from 'react'
import styles from './styles.module.scss'

export const ListTags = ({ tags, backgroundColor }) => {
  const tagName = tags?.attributes?.description

  return (
    <div style={{ backgroundColor }} className={styles.tag}>
      <p className={styles.tagText}>{tagName}</p>
    </div>
  )
}
